import React from 'react';
import { FaBuilding, FaMapMarkerAlt, FaGlobe } from 'react-icons/fa';
import { PROFESSIONAL_TYPES } from './professionalSignupConstants';

export const SignupStep2Professional = ({
  formData,
  setFormData,
  handleChange,
  newSpecialty,
  setNewSpecialty,
  addSpecialty,
  removeSpecialty,
}) => (
  <div className="space-y-4" data-testid="step-2">
    <div>
      <label className="block text-gray-700 font-medium mb-2">Professional Type *</label>
      <div className="grid grid-cols-2 gap-3">
        {PROFESSIONAL_TYPES.map(type => (
          <button
            key={type.value}
            type="button"
            onClick={() => setFormData(prev => ({ ...prev, professional_type: type.value }))}
            className={`p-3 rounded-lg border-2 text-left transition ${
              formData.professional_type === type.value
                ? 'border-blue-600 bg-blue-50'
                : 'border-gray-200 hover:border-gray-300'
            }`}
            data-testid={`type-${type.value}`}
          >
            <span className="text-xl mr-2">{type.icon}</span>
            <span className="text-sm font-medium text-gray-800">{type.label}</span>
          </button>
        ))}
      </div>
    </div>

    <div>
      <label className="block text-gray-700 font-medium mb-2">Company/Practice</label>
      <div className="relative">
        <FaBuilding className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
        <input
          type="text"
          name="company"
          value={formData.company}
          onChange={handleChange}
          className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-blue-600"
          placeholder="Smith Financial Group"
          data-testid="company-input"
        />
      </div>
    </div>

    <div>
      <label className="block text-gray-700 font-medium mb-2">Bio / About *</label>
      <textarea
        name="bio"
        value={formData.bio}
        onChange={handleChange}
        rows="4"
        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-blue-600"
        placeholder="Tell families about your experience, approach, and how you can help them..."
        required
        data-testid="bio-input"
      />
      <p className="text-xs text-gray-500 mt-1">{formData.bio.length}/500 characters</p>
    </div>

    <div>
      <label className="block text-gray-700 font-medium mb-2">Specialties</label>
      <div className="flex space-x-2 mb-2">
        <input
          type="text"
          value={newSpecialty}
          onChange={(e) => setNewSpecialty(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), addSpecialty())}
          className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
          placeholder="e.g., Retirement Planning"
          data-testid="specialty-input"
        />
        <button
          type="button"
          onClick={addSpecialty}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          Add
        </button>
      </div>
      <div className="flex flex-wrap gap-2">
        {formData.specialties.map((specialty, i) => (
          <span
            key={i}
            className="inline-flex items-center px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm"
          >
            {specialty}
            <button
              type="button"
              onClick={() => removeSpecialty(specialty)}
              className="ml-2 text-blue-600 hover:text-blue-800"
            >
              &times;
            </button>
          </span>
        ))}
      </div>
    </div>

    <div className="grid grid-cols-2 gap-4">
      <div>
        <label className="block text-gray-700 font-medium mb-2">Location</label>
        <div className="relative">
          <FaMapMarkerAlt className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            name="location"
            value={formData.location}
            onChange={handleChange}
            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
            placeholder="City, State"
            data-testid="location-input"
          />
        </div>
      </div>
      <div>
        <label className="block text-gray-700 font-medium mb-2">Website</label>
        <div className="relative">
          <FaGlobe className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="url"
            name="website"
            value={formData.website}
            onChange={handleChange}
            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
            placeholder="https://..."
            data-testid="website-input"
          />
        </div>
      </div>
    </div>
  </div>
);
